// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2JDZe","dragIcon":"SortableItem_dragIcon__25mPg","disabled":"SortableItem_disabled__2bWLg"};